import { Component, Input, output } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-settlement]',
  template: `
    <td class="align-middle">
      <span>{{settlement?.name}}</span>
      <span *ngIf="isArchived" class="badge bg-secondary ms-2">Archivado</span>
    </td>
    <td class="align-middle d-none d-md-table-cell">{{settlement?.address}}, {{settlement?.city}}, {{settlement?.state}}, {{settlement?.zip}}</td>
    <td class="align-middle text-center">{{settlement?.units?.length}}</td>
    <td class="align-middle text-center">{{settlement?.zone?.name}}</td>
    <td class="align-middle">{{ settlement?.legal_entity?.business_name || '—' }}</td>
    <td class="align-middle text-center">
      <div *ngFor="let tanque of settlement?.tanques">{{tanque.name}}</div>
    </td>
    <td class="align-middle">
    <div ngbDropdown class="d-inline-block w-100 p-0" style="height: 100%; " >
      <button type="button" class="btn btn-link w-100 btn-lg dropdown-toggle py-1 px-2" style="height: 100%; " id="dropdownBasic1" ngbDropdownToggle >
        <fa-icon [icon]="icons.faEllipsisVertical" class="m-1"></fa-icon>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <!-- (click)="toggleData()" -->
        <button ngbDropdownItem routerLink="edit/{{settlement.id}}" *ngIf="!isArchived && authService.canEditSettlements()">
          <fa-icon [icon]="icons.faEdit" size="1x" class="p-2"></fa-icon>
          Editar
        </button>
        <button ngbDropdownItem routerLink="{{settlement.id}}">
          <fa-icon [icon]="icons.faGears" size="1x" class="p-2"></fa-icon>
          Mostrar detalles
        </button>
        <button
          ngbDropdownItem
          *ngIf="authService.hasPermission('can_edit_settlements')"
          (click)="requestEnabledChange()">
          <fa-icon [icon]="isArchived ? icons.faRotateLeft : icons.faBan" size="1x" class="p-2"></fa-icon>
          {{ isArchived ? 'Reactivar' : 'Archivar' }}
        </button>
      </div>
    </div>
    </td>
  `,
  styleUrls: []
})
export class TrSettlementComponent {
  @Input() settlement: any;
  @Input() profile: any;
  @Input() permissions: any;
  @Input() isArchived = false;
  readonly enabledChange = output<{ settlementId: number; enabled: boolean }>();

  constructor(
    public icons: IconsService,
    public authService: AuthService
  ) { }

  requestEnabledChange(): void {
    if (!this.authService.hasPermission('can_edit_settlements')) return;
    this.enabledChange.emit({
      settlementId: Number(this.settlement?.id),
      enabled: this.isArchived
    });
  }

}
